import { flexRender, HeaderGroup } from "@tanstack/react-table";
import { ArrowUpDown } from "lucide-react";
import { TableHead, TableHeader, TableRow } from "./table";

interface TableHeaderProps<TData> {
  headerGroups: HeaderGroup<TData>[];
  variant?: string;
}

export const CustomTableHeader = <TData,>({
  headerGroups,
  variant,
}: TableHeaderProps<TData>) => {
  return (
    <TableHeader
      className={
        variant === "transaction" ? "BookEZ_accordion_header_color" : ""
      }
      tableTheme={variant === "transaction" ? "gray" : "default"}
    >
      {headerGroups.map((headerGroup, groupIdx) => (
        <TableRow
          key={headerGroup.id}
          className={
            variant === "transaction"
              ? "border-b BookEZ_table_border_color"
              : ""
          }
        >
          {headerGroup.headers.map((header, i) => (
            <TableHead
              key={header.id}
              className={
                variant === "transaction"
                  ? "BookEZ_font_bold BookEZ_accordion_header_text_color px-4 py-2 transition-colors duration-200"
                  : "BookEZ_font_bold BookEZ_table_header_text_color px-4 py-2 transition-colors duration-200"
              }
              style={{ width: `${header.getSize()}px` }}
            >
              {header.isPlaceholder ? null : (
                <div
                  onClick={() =>
                    variant !== "transaction" &&
                    header.column.toggleSorting(
                      header.column.getIsSorted() === "asc"
                    )
                  }
                  className={`flex items-center space-x-2 ${
                    variant !== "transaction" ? "cursor-pointer" : ""
                  }`}
                >
                  <p>
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                  </p>
                  {header.column.getCanSort() && variant !== "transaction" && (
                    <ArrowUpDown className="h-4 w-4 cursor-pointer" />
                  )}
                </div>
              )}
            </TableHead>
          ))}
        </TableRow>
      ))}
    </TableHeader>
  );
};
